<template>
	<modal v-model="modalOpen">
		<div slot="label" class="knighthood">
			<div class="knighthood-symbol clickable">
				<img
					class="knighthood-icon"
					:src="imageSource"
					alt="knighthood23.svg"
				/>
			</div>
		</div>
		<knighthood-modal v-if="modalOpen === true" />
	</modal>
</template>

<script>
import { convertToCdnUrl } from 'utils';

export default {
	data() {
		return {
			modalOpen: false,
			imageSource: convertToCdnUrl('/img/member/knighthood/knighthood23-thumb.svg'),
		};
	},
  	methods: {
    	convertToCdnUrl,
  	},
};
</script>